// THIS FILE IS AUTO GENERATED
var GenIcon = require('../lib').GenIcon
module.exports.BiCoffeeTogo = function BiCoffeeTogo (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"path","attr":{"d":"M7,22h10c0.498,0,0.92-0.366,0.99-0.858L19.867,8H21V6h-1.382l-1.724-3.447C17.725,2.214,17.379,2,17,2H7 C6.621,2,6.275,2.214,6.105,2.553L4.382,6H3v2h1.133L6.01,21.142C6.08,21.634,6.502,22,7,22z M17.418,11H6.582L6.153,8h11.693 L17.418,11z M7.867,20l-0.429-3h9.123l-0.429,3H7.867z M7.618,4h8.764l1,2H6.618L7.618,4z"}}]})(props);
};
